module.exports = __webpack_public_path__ + "img/battle_section3_item3.feecc9de.png";